import React, { Component } from "react";
import Header from "./Header";
import MismatchBanner from "components/header/MismatchBanner";
import HeaderPersistentBar from "components/header/HeaderPersistentBar";
import DataContainer from "components/utility/data-container/DataContainer";
import StickyHeaderContainer from "components/utility/sticky-header/StickyHeaderContainer";
import StickyHeader from "components/utility/sticky-header/StickyHeader";
import StickyPromoBanner from "components/sticky-promo-banner/StickyPromoBanner";

class HeaderStandalone extends Component {
	render() {
		return (
			<StickyHeaderContainer>
				<StickyHeader>
					<DataContainer data="mismatchBanner">
						<MismatchBanner />
					</DataContainer>
					<DataContainer data="topPersistentBar">
						<HeaderPersistentBar
							color="cement"
							type="top"
							dataset={{ withoutLine: "true", publicSite: "true" }}
						/>
					</DataContainer>
					<DataContainer data="stickyPromoBanner">
						<StickyPromoBanner />
					</DataContainer>
					<Header />
				</StickyHeader>
			</StickyHeaderContainer>
		);
	}
}

export default HeaderStandalone;
